import { Badge } from "@/components/ui/badge";

export function StatusBadge({ isActive }: { isActive: boolean }) {
  return (
    <Badge variant={isActive ? "success" : "gray"}>
      {isActive ? "Active" : "Inactive"}
    </Badge>
  );
}
